<template>
    <div v-if="route || href" v-bind="linkProps" :class="buttonClass">
        <div v-if="icon" class="button__icon">
            <common-icon :name="icon" size="large"></common-icon>
        </div>

        <div class="button__label">
            {{ label }}
        </div>
    </div>

    <button v-else :disabled="isDisabled || isProcessing" :type="buttonType" :class="buttonClass" @click="onButtonClick($event)">
        <div v-if="icon" class="button__icon">
            <common-icon :name="icon" size="large"></common-icon>
        </div>

        <div class="button__label">
            {{ label }}
        </div>

        <common-loader :isProcessing="isProcessing" :color="loaderColor"></common-loader>
    </button>
</template>

<script>
    const OUTLINE_BUTTON_TYPES = ['secondary', 'tertiary', 'link', 'already-in-network']

    export default {
        props: {
            route: { type: Object, default: undefined },
            event: { type: Object, default: undefined },
            href: { type: String, default: undefined },
            type: { type: String, required: true },
            size: { type: String, default: 'large' },
            label: { type: String, default: undefined },
            icon: { type: String, default: undefined },
            isSubmittable: { type: Boolean, default: true },
            isProcessing: { type: Boolean, default: false },
            isDisabled: { type: Boolean, default: false },
            isFluid: { type: Boolean, default: false },
            isClicked: { type: Boolean, default: false },
        },

        computed: {
            buttonClass() {
                return {
                    button: true,
                    [`button--type-${this.type}`]: true,
                    [`button--size-${this.size}`]: true,
                    'button--is-processing': this.isProcessing,
                    'button--is-disabled': this.isDisabled,
                    'button--is-fluid': this.isFluid,
                    [`button--is-clicked-${this.type}`]: this.isClicked,
                }
            },

            // Filled buttons get a white spinner; outline and text buttons keep the gradient.
            loaderColor() {
                return OUTLINE_BUTTON_TYPES.includes(this.type) ? '' : '#fff'
            },

            buttonType() {
                return this.isSubmittable ? 'submit' : 'button'
            },

            linkProps() {
                return this.route ? { is: 'router-link', to: this.route } : { is: 'a', href: this.href }
            },
        },

        methods: {
            onButtonClick(event) {
                if (!this.isSubmittable) {
                    event.preventDefault()
                }

                if (this.event) {
                    return this.emitEvent(this.event)
                }

                this.emitEvent({ name: 'click', payload: event })
            },
        },
    }
</script>
